import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource)

let api = process.env.API_URL
let prefix = '/matchs'

export default {
  get: {
    /**
     * Get matchs.
     *
     * @return {Promise}
     */
    getMatchs () {
      return Vue.http.get(api + prefix)
    },
    /**
     * Get matchs the user has to confirm.
     *
     * @return {Promise}
     */
    getMatchsToConfirm () {
      return Vue.http.get(api + prefix + '/to-confirm')
    },
    /**
     * Get match.
     *
     * @return {Promise}
     */
    getMatch (id) {
      return Vue.http.get(api + prefix + '/' + id)
    },
    /**
     * Get match types.
     *
     * @return {Promise}
     */
    getMatchTypes () {
      return Vue.http.get(api + prefix + '/' + 'types')
    }
  },
  post: {
    /**
     * Create a new match.
     *
     * @return {Promise}
     */
    newMatch (body) {
      return Vue.http.post(api + prefix, body)
    },
    /**
     * Create a new match comment.
     *
     * @return {Promise}
     */
    newComment (matchId, body) {
      return Vue.http.post(api + prefix + '/' + matchId + '/comments', body)
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/matchs.js